"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttons = void 0;
const baseColors_1 = __importDefault(require("./baseColors"));
const border_1 = require("./border");
const fonts_1 = require("./fonts");
const spacings_1 = require("./spacings");
exports.buttons = {
    types: {
        primary: {
            color: baseColors_1.default.neutral.colorWhite,
            border: border_1.border.style.none,
            backgroundColor: baseColors_1.default.brandcolor.secondaryMedium,
            '&:hover': {
                backgroundColor: baseColors_1.default.brandcolor.secondaryDark,
            },
            '&:active': {
                backgroundColor: baseColors_1.default.brandcolor.secondaryDarkest,
            },
        },
        secondary: {
            color: baseColors_1.default.brandcolor.primaryMedium,
            border: `${border_1.border.width.borderSm} ${border_1.border.style.solid} ${baseColors_1.default.brandcolor.primaryMedium}`,
            backgroundColor: baseColors_1.default.neutral.colorLightest,
            '&:hover': {
                color: baseColors_1.default.brandcolor.primaryLight,
                borderColor: `${baseColors_1.default.brandcolor.primaryLight}`,
            },
            '&:active': {
                color: baseColors_1.default.brandcolor.primaryDark,
                borderColor: `${baseColors_1.default.brandcolor.primaryDark}`,
            },
        },
        default: {
            border: border_1.border.style.none,
            padding: 'initial',
            height: 'auto',
            backgroundColor: baseColors_1.default.transparent,
        },
        disabled: {
            color: baseColors_1.default.neutral.colorWhite,
            border: border_1.border.style.none,
            backgroundColor: baseColors_1.default.neutral.colorLight,
            '&:hover': {
                cursor: 'not-allowed',
            },
        },
    },
    sizes: {
        small: {
            fontSize: fonts_1.fonts.sizes.font2xs,
            padding: `${spacings_1.spacings.padding.spacing3xs} ${spacings_1.spacings.padding.spacingXs}`,
            height: `${spacings_1.spacings.layout.spacingSm}`,
        },
        medium: {
            fontSize: fonts_1.fonts.sizes.fontXs,
            padding: `${spacings_1.spacings.padding.spacing2xs} ${spacings_1.spacings.padding.spacingXs}`,
            height: `${spacings_1.spacings.layout.spacingLg}`,
        },
        large: {
            fontSize: fonts_1.fonts.sizes.fontSm,
            padding: `${spacings_1.spacings.padding.spacing2xs} ${spacings_1.spacings.padding.spacingMd}`,
            height: `${spacings_1.spacings.layout.spacingXl}`,
        },
    },
};
//# sourceMappingURL=buttons.js.map